import { GROUP_LIST_GET_DONE } from '../../action/group';

const initState = {
	data: [],
	error: null,
	status: null,
	currentlogedInuser: null,
};

export const productGroupReducer = (state = initState, action) => {
	switch (action.type) {
		case GROUP_LIST_GET_DONE:
			return {
				...state,
				data: {
					data: action?.payload?.data?.data,
					status: action?.payload?.data?.status,
					error: null,
				},
			};
		default:
			return state;
	}
};
